<button *ngIf="options.closeButton" (click)="close()" class="toast-close-button" aria-label="Close">
  <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
  {{ title }} <ng-container *ngIf="duplicatesCount">[{{ duplicatesCount + 1 }}]</ng-container>
</div>
<div
  *ngIf="message && options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [innerHTML]="message"
>
  <p [innerHTML]="message"></p>
</div>
<div
  *ngIf="message && !options.enableHtml"
  role="alertdialog"
  aria-live="polite"
  [class]="options.messageClass"
  [attr.aria-label]="message"
>
  {{ message }}
</div>
<div class="toastActions">
  <button
    mat-icon-button
    (click)="dockBodyCamera()"
    matTooltip="View Stream"
    matTooltipPosition="above"
  >
    <sn-icon fontSet="fas" fontIcon="fa-play"></sn-icon>
  </button>
  <button
    mat-icon-button
    (click)="dockNearbyCameras()"
    matTooltip="Dock Nearby CCTV Cameras"
    matTooltipPosition="above"
  >
    <sn-icon fontSet="fas" fontIcon="fa-camera-cctv"></sn-icon>
  </button>
</div>
